import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import SiteShell from "./SiteShell";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:lang" element={<SiteShell />} />
        <Route path="/:lang/:tab" element={<SiteShell />} />
        <Route path="*" element={<Navigate to="/en" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
